import Quill from "quill";

const Inline = Quill.import('blots/inline');

class HideBlot extends Inline {
    static blotName: string;
    static tagName: string;
    static className: string;
}
HideBlot.blotName = 'hide';
HideBlot.tagName = 'inline';
HideBlot.className = 'ql-hide';

Quill.register(HideBlot, true);
